import React, { useState, useEffect } from 'react';
import axios from 'axios';

const SummaryItem = (props) => {

    return (
        <tr>
            <td className="first">{props.question.questionText}</td>
            <td className="second">
                {props.questionResponse.responseText}
            </td>
            <td className="third">
                {props.questionResponse.commentText}
            </td>
        </tr>
    )
}
export default SummaryItem;